
<section>
    <div class="flex-col flex space-y-6 justify-center items-center">
        <div class="flex flex-row gap-x-2 w-full h-full justify-center max-lg:flex-col max-lg:space-y-6">
            <app-payment-methods
                class="lg:w-1/2 w-full h-full"
                [checkoutProcessView]="true"
                [currentPaymentMethod]="currentPaymentMethod"
                [dealerCode]="dealerCode"
                (closeModal)="orderProcess()">
            </app-payment-methods>        
           <!-- <app-terms (termsAndConditions)="termsCheck($event)" class="max-lg:hidden lg:w-1/2 w-full h-full"></app-terms> -->
        </div>
        <ng-container *ngIf="currentPaymentMethod?.IsValidated">
            <div class="lg:w-1/2 w-full" *ngIf="showUpfrontPayment">
                <app-upfront-payment  *ngIf="upFrontAmount !== null && upFrontAmount > 0" [checkoutProcessView]="true" [upFrontAmount]="upFrontAmount" [leadId]="this._webStorage.CartInfo.getValue().LeadEntityID"></app-upfront-payment>
            </div>
            <app-debit-orders 
                class="lg:w-1/2 w-full" 
                *ngIf="isDebitOrderRequired" 
                [checkoutProcessView]="true" 
                [debitOrderMandate]="debitOrderMandate" 
                [lead]="lead"
                [dealerCode]="dealerCode"
                [hasDebitOrderBeenSigned]="hasDebitOrderBeenSigned"
                (debitOrderMandateSigned)="checkForAcceptedDebitOrder()">
            </app-debit-orders>
        </ng-container>
        <!-- <app-terms class="lg:w-1/2 w-full" (termsAndConditions)="termsCheck($event)"></app-terms> -->
    </div>
</section>
 